module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    class: {
      'filter-list-item': true, disabled: (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number && _vm.filter === 'date')
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.computedIcon) ? _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": _vm.computedIcon,
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.computedLabel))]), _vm._v(" "), _c('span', {
    staticClass: "close"
  }, [_c('icon', {
    attrs: {
      "name": "times",
      "scale": 0.8
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc85d242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Accomodation/List/Filter/FilterListItem.vue
// module id = 1042
// module chunks = 0